var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"emi-index-footer"},[_c('div',{staticClass:"emi-index-footer-box"},[_c('p',[_vm._v(" Copyright © 2020 MIUI 京ICP备10046444号")]),_c('img',{attrs:{"alt":"可信网站","src":"http://s1.mi.com/zt/12052601/cnnicVerifyseal.png","width":"68","height":"25"}})])])
}]

export { render, staticRenderFns }